/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
'use client';
import React from 'react';
import { ImageInfo } from '../data/dataType';
import { ImageUpload } from './ImageUpload';
import { HiMinusCircle, HiPlusCircle } from 'react-icons/hi2';
import { v4 } from 'uuid';
import { FaFileImage } from 'react-icons/fa';
import { AttributesInput } from './AttributesInput';
import Modal from './Modal';
import { createPortal } from 'react-dom';
import { imageFields } from '../../app/[locale]/admin/lib/imageFields';
import {
    getNewPosition,
    setFieldValues,
    sortAscBy,
} from '../../app/[locale]/admin/lib/util';
import { FormikValues } from 'formik';

export const ImagesInput: React.FC<{
    itemId: number | string;
    locale: string;
    bucket: string;
    folder: string;
    value: ImageInfo[];
    onChange: (value: ImageInfo[]) => void;
}> = ({ itemId, bucket, folder, locale, value, onChange }) => {
    const [imagesInfo, setImagesInfo] = React.useState<
        (ImageInfo | undefined)[] | undefined
    >(value);

    const [attrEditing, setAttrEditing] = React.useState<string | undefined>(
        undefined,
    );

    const [_document, set_document] =
        React.useState<globalThis.Document | null>(null);

    React.useEffect(() => {
        set_document(document);
    }, []);

    const addImage = () => {
        const initialValue: ImageInfo = {
            id: v4(),
            title: { fr: '', en: '' },
            link: { fr: '', en: '' },
            position: getNewPosition(imagesInfo, 'position'),
        };
        const newValue = [...(value || []), initialValue];
        setImagesInfo(newValue);
    };

    const changeImageInfo = (
        imageUploadProps: ImageInfo,
        imageInfo: ImageInfo,
    ) => {
        const newValue = {
            ...imageUploadProps,
            id: imageInfo.id,
            title: imageInfo.title,
            link: imageInfo.link,
            position: imageInfo.position,
        };
        const newValues = [
            ...(value.filter(f => f.id !== imageInfo.id) || []),
            newValue,
        ];
        setImagesInfo(newValues);
        onChange(newValues);
    };

    const submitChanges = (value: FormikValues, imageInfo: ImageInfo) => {
        if (imagesInfo) {
            const newValue = setFieldValues(
                value,
                imageInfo,
                imageFields,
                locale,
            );
            const concateValue = { ...imageInfo, ...newValue };
            const newValues = [
                concateValue,
                ...imagesInfo.filter(f => f?.id !== concateValue?.id),
            ];
            setImagesInfo(newValues);
            setAttrEditing(undefined);
            onChange(newValues);
        }
    };

    return (
        <div>
            <div className="flex justify-end">
                <HiPlusCircle
                    className="h-10 w-10 fill-gray-700 stroke-gray-900 border-gray-900 cursor-pointer"
                    onClick={addImage}
                />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                {sortAscBy(imagesInfo, 'position')?.map(
                    (imageInfo: ImageInfo) =>
                        imageInfo && (
                            <div key={imageInfo.id || v4()}>
                                <div className="flex justify-start">
                                    <FaFileImage
                                        className="absolute mt-3 ml-2 h-8 w-8 fill-gray-700 stroke-gray-900 border-gray-900 cursor-pointer"
                                        onClick={() =>
                                            setAttrEditing(imageInfo.id)
                                        }
                                    />
                                </div>
                                <div className="flex justify-end">
                                    <HiMinusCircle
                                        className="absolute mt-2 mr-1 h-10 w-10 fill-gray-700 stroke-gray-900 border-gray-900 cursor-pointer"
                                        onClick={() => {
                                            const newValue = [...value].filter(
                                                x => x.id !== imageInfo?.id,
                                            );
                                            setImagesInfo(newValue);
                                            onChange(newValue);
                                        }}
                                    />
                                </div>
                                <div className="flex p-2">
                                    {_document &&
                                        createPortal(
                                            <Modal
                                                opacity={40}
                                                showModal={
                                                    attrEditing ===
                                                    (imageInfo?.id || null)
                                                }
                                            >
                                                <AttributesInput
                                                    attributes={imageInfo}
                                                    fields={imageFields}
                                                    locale={locale}
                                                    onCancel={() =>
                                                        setAttrEditing(
                                                            undefined,
                                                        )
                                                    }
                                                    onSubmitChanges={(
                                                        value: FormikValues,
                                                    ) =>
                                                        submitChanges(
                                                            value,
                                                            imageInfo,
                                                        )
                                                    }
                                                    title="Image info"
                                                />
                                            </Modal>,
                                            _document.body,
                                        )}
                                </div>
                                <ImageUpload
                                    bucket={bucket}
                                    folder={folder}
                                    imageHeight={208}
                                    itemId={itemId}
                                    locale={locale}
                                    multiple={true}
                                    onChange={imageUploadProps =>
                                        changeImageInfo(
                                            imageUploadProps,
                                            imageInfo,
                                        )
                                    }
                                    value={imageInfo}
                                />
                            </div>
                        ),
                )}
            </div>
        </div>
    );
};
